export default {
      id: "consultation-usage",
      viewBox: "0 0 64 64",
      url: __webpack_public_path__ + "assets/icons/icon-sprite.svg#consultation-usage",
      toString: function () {
        return this.url;
      }
    }